import { createI18n } from 'vue-i18n';

import en from '../../assets/locales/en.json';
import fr from '../../assets/locales/fr.json';
import collections from '../../assets/badges/collections.json';

let concatFr = { ...fr, collections: {} };
let concatEn = { ...en, collections: {} };

for (var collection of collections) {
  concatFr.collections[collection.id] = { name: collection.name.fr };
  concatEn.collections[collection.id] = { name: collection.name.en };
}

// Langues supportées par l'app (traductions vue-i18n)
export const SUPPORTED_LOCALES = ['en', 'fr'];
const FALLBACK_LOCALE = 'en';

// 🌍 Détection de la langue : localStorage > navigateur > fallback
function getInitialLocale() {
  // 1. Priorité : choix utilisateur sauvegardé
  const savedLocale = localStorage.getItem('locale');
  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    return savedLocale;
  }

  // 2. Sinon : langue du navigateur
  const browserLang = typeof navigator !== 'undefined' && (navigator.language || navigator.userLanguage || '');
  const langCode = browserLang ? browserLang.split('-')[0] : '';

  // 3. Utiliser la langue du navigateur si supportée, sinon fallback
  return SUPPORTED_LOCALES.includes(langCode) ? langCode : FALLBACK_LOCALE;
}

/** Lit uniquement la langue du navigateur (sans localStorage). Pour languagechange. */
export function getBrowserLocaleOnly() {
  if (typeof navigator === 'undefined') return FALLBACK_LOCALE;
  if (navigator.languages && navigator.languages.length > 0) {
    for (const lang of navigator.languages) {
      const code = lang.split('-')[0].toLowerCase();
      if (SUPPORTED_LOCALES.includes(code)) return code;
    }
  }
  const lang = navigator.language || navigator.userLanguage || '';
  const code = lang ? lang.split('-')[0].toLowerCase() : '';
  return SUPPORTED_LOCALES.includes(code) ? code : FALLBACK_LOCALE;
}

// Create i18n instance with options
const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages: {
    en: concatEn,
    fr: concatFr,
  },
});

// Synchroniser l'attribut lang du document avec la locale (a11y, SEO)
export function syncDocumentLang(locale) {
  if (typeof document !== 'undefined' && document.documentElement && locale) {
    document.documentElement.lang = SUPPORTED_LOCALES.includes(locale) ? locale : FALLBACK_LOCALE;
  }
}

export default i18n;
